<template>
  <router-link class="pixso-button" :to="to">
    {{ buttonText }}
  </router-link>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  text: {
    type: String,
    default: ''
  },
  to: {
    type: String,
    default: '/'
  }
})

const buttonText = computed(() => props.text || t('Common.learnDetails'))
</script>

<style scoped>
.pixso-button {
  box-sizing: border-box;
  width: auto;
  min-width: 200px;
  max-width: 100%;
  padding: 0 24px;
  height: 50px;
  border-radius: 40px;
  background: var(--pixso-color-footer-text);
  color: #000;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--pixso-fs-20);
  font-weight: 700;
  line-height: var(--pixso-lh-20);
  text-decoration: none;
  white-space: nowrap;
  transition: background-color 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.pixso-button:hover {
  background: var(--pixso-color-primary);
  color: #000;
  transform: translateY(-1px);
}

@media (max-width: 768px) {
  .pixso-button {
    min-width: 148px;
    padding: 0 16px;
    height: 42px;
    font-size: var(--pixso-fs-16);
    line-height: var(--pixso-lh-16);
  }
}
</style>
